import {Controller} from "@/controllers/Controller";

/**
 * Controller for group API
 */
export class BusinessController extends Controller {

    static getAll(urlParams) {
        return this.requestBuilder("GET",`/business/businesses/table/all${urlParams}`, true);
    }

    static getAllFilteredByUnpaidCollections(urlParams) {
        return this.requestBuilder("GET",`/business/businesses/table/all-filtered-by-unpaid-collections${urlParams}`, true);
    }

    // Une ligne par contrat ayant un acompte
    static getDepositTable(urlParams) {
        return this.requestBuilder("GET",`/business/businesses/table/deposits${urlParams}`, true);
    }

    // Une ligne par contrat ayant des avoirs, tous ses avoirs sur la même ligne
    static getCreditNoteTable(urlParams) {
        return this.requestBuilder("GET",`/business/businesses/table/credit-notes${urlParams}`, true);
    }

    static getAllForClient(urlParams) {
        return this.requestBuilder("GET",`/business/businesses/table/for-client${urlParams}`, true);
    }

    static get(id) {
        return this.requestBuilder("GET",`/business/businesses/${id}`, true);
    }

    static post(body) {
        return this.requestBuilder("POST",`/business/businesses`, true, body);
    }

    static patch(id, body) {
        return this.requestBuilder("PATCH",`/business/businesses/${id}`, true, body);
    }

    // Dossiers en cours d'un client (auxquels un de ses contrats est déjà rattaché), proposés à la création d'un devis
    static getClientOrders(clientId) {
        return this.requestBuilder("GET",`/business/businesses/client-orders/${clientId}`, true);
    }

    static createOrder(id) {
        return this.requestBuilder("PATCH",`/business/businesses/create-order/${id}`, true);
    }

    static generateInvoiceDocument(id){
        return this.requestBuilder("PATCH",`/business/businesses/generate-invoice-document/${id}`, true);
    }

    static generateDepositDocument(id){
        return this.requestBuilder("PATCH",`/business/businesses/generate-deposit-document/${id}`, true);
    }

    static reloadClientInformations(id){
        return this.requestBuilder("PATCH",`/business/businesses/reload-client-informations/${id}`, true);
    }

    static validateSignature(id){
        return this.requestBuilder("PATCH",`/business/businesses/validate-signature/${id}`, true);
    }

    static getBySignature(hash){
        return this.requestBuilder("GET",`/business/businesses/by-signature/${hash}`, true);
    }

    static sign(hash, body){
        return this.requestBuilder("POST",`/business/businesses/sign/${hash}`, false, body);
    }

    static getInvoicePdf(businessId){
        return this.requestBuilder("GET",`/business/businesses/generate-invoice-pdf/${businessId}`, true, undefined, {'Accept': 'application/pdf'});
    }

    static getQuotePdf(businessId){
        return this.requestBuilder("GET",`/business/businesses/generate-quote-pdf/${businessId}`, true, undefined, {'Accept': 'application/pdf'});
    }

    static getDepositPdf(businessId){
        return this.requestBuilder("GET",`/business/businesses/generate-deposit-pdf/${businessId}`, true, undefined, {'Accept': 'application/pdf'});
    }

    static getCreditNotePdf(creditNoteNumber){
        return this.requestBuilder("GET",`/business/businesses/generate-creditnote-pdf/${creditNoteNumber}`, true, undefined, {'Accept': 'application/pdf'});
    }

    static getInvoicePdfFromClient(businessId){
        return this.requestBuilder("GET",`/business/businesses/generate-invoice-pdf-from-client/${businessId}`, true, undefined, {'Accept': 'application/pdf'});
    }

    static getQuotePdfFromClient(businessId){
        return this.requestBuilder("GET",`/business/businesses/generate-quote-pdf-from-client/${businessId}`, true, undefined, {'Accept': 'application/pdf'});
    }

    static postAmendment(body) {
        return this.requestBuilder("POST",`/business/businesses/amendment`, true, body);
    }

    static postCreditNote(body) {
        return this.requestBuilder("POST",`/business/businesses/credit-note`, true, body);
    }

    static patchCreditNote(body) {
        return this.requestBuilder("PATCH",`/business/businesses/credit-note`, true, body);
    }

    static postDuplicateBusiness(body, id) {
        return this.requestBuilder("POST",`/business/businesses/duplicate/${id}`, true, body);
    }

    // Nombre de contrats affichés par défaut dans chaque rubrique du menu Contrats
    static getTabCounts() {
        return this.requestBuilder("GET",`/business/businesses/tab-counts`, true);
    }

    // Ce qu'il reste à faire : devis / factures non envoyés, impayés échus, prospects
    static getTodoSummary() {
        return this.requestBuilder("GET",`/business/businesses/todo-summary`, true);
    }

    static getLogs() {
        return this.requestBuilder("GET",`/business/businesses/logs/all`, true);
    }

    static patchStatus(businessId, body) {
        return this.requestBuilder("PATCH",`/business/businesses/status/${businessId}`, true, body);
    }

    static patchDepositStatus(businessId, body) {
        return this.requestBuilder("PATCH",`/business/businesses/deposit/status/${businessId}`, true, body);
    }

    static patchCreditNoteStatus(businessId, body) {
        return this.requestBuilder("PATCH",`/business/businesses/credit-note/status/${businessId}`, true, body);
    }
}